import { useState } from 'react';

import { useInfiniteQuery, useQuery } from 'react-query';

import { getPushResults } from '@api/push';
import type { GetPushResultsQuery } from '@api/push/getPushResults';

function useGetPushResults({
  notificationId,
  ...props
}: Partial<GetPushResultsQuery> & { notificationId: number }) {
  const [total, setTotal] = useState<number>(0);

  const response = useQuery(
    ['PUSH_RESULTS', notificationId, props?.page, props?.q, props?.dir],
    async ({ pageParam: page = 1 }) => {
      const query: GetPushResultsQuery = {
        page,
        limit: 100,
        sort: 'createdAt',
        dir: 'desc',
        ...props,
      };

      const response = await getPushResults({ query, path: { notificationId } });

      if (response) setTotal(response.count);

      return response;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );

  return { ...response, data: response.data ? response.data.rows : [], total };
}

export default useGetPushResults;
